<template>
    
    <ContainerView class="flex w-full h-full" gradient>

        <LoadingControl v-show="loading" :loading="loading" />

        <Modal v-show="this.show_message_modal" v-bind:display="this.show_message_modal" :error="this.error"
            :note="this.note" :success="this.success" z_value="z-50" @positiveClick="closed" :positiveButton="'OK'"
            :default_width="'max-w-lg'" id='vote_modal'>
            <div class="w-full -mt-2 p-5 flex flex-col text-lg text-gray-500 text-left" :class="note_style">
                {{ this.modal_message }}
            </div>
            <div class="w-full text-lg text-left text-gray-500 p-5 " v-show="note">
                <span v-text="'Your PIN is confidential - '" />
                <span v-text="'do not share it '" class="text-red-500" />
                <span v-text="'with anyone to ensure the protection of your account.'" />
            </div>
        </Modal>
        <Modal v-show="show_otp_modal" v-bind:display="show_otp_modal" :z_value="'z-40'" :closable="true"
            @closed="show_otp_modal = false" :default_width="'max-w-xl'" id='otp_modal'>
            <div class="pt-6">
                <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Verify your Account</h2>
                <p class="mb-5 text-left text-base">Please enter the One-Time Password (OTP) we have sent to your Email Address and Mobile Number to verify your
                    identity.</p>
                  <div class="bg-gray-50 rounded-xl p-3 flex flex-col justify-center text-center items-center">
                    <span class="mb-1 font-semibold text-base lg:text-lg" v-text="'Email Address'" />
                    <div v-show="!show_otp_email" class="bg-theme-primaryLight px-4 py-2 rounded-full font-semibold text-theme-primary text-base flex justify-center items-center align-middle text-center my-2"><span>Verified</span><img src="@/assets/images/papsi_check_icon.svg" class="ml-1 w-5 h-5"></div>
                    <div class="p-2 space-y-3 place-items-center" v-show="show_otp_email">
                        <v-otp-input :is-disabled="false" ref="otp_email" v-show="show_otp_email"
                            input-classes="otp-input-register" :conditionalClass="['1', '2', '3', '4', '5', '6']" separator=" "
                            :input-type="'number'" inputmode="numeric" :num-inputs="6" @on-change="handleOnChangeEmail"
                            @on-complete="handleOnCompleteEmail" v-model:value="otp_email" :should-auto-focus="true"
                            :should-focus-order="true" :key="otpInputKey"/>
                        
                        <div class="flex flex-col pt-1 gap-3 w-full justify-center text-center text-gray-400 text-sm">
                            <!-- <span class="text-red-500" v-text="error_otp_email_message" v-show="show_error_otp_email" />  -->
                            <!-- Error Message Display -->
                            <div v-show="error_otp_email_message" class="w-full flex items-center justify-center text-center mt-2 rounded-full">
                                            <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium" 
                                            v-text="error_otp_email_message" 
                                />
                            </div>
                            <div class="flex flex-row gap-2 w-full justify-center text-center text-gray-400 text-sm">
                                <p>Didn't receive a code? <span v-show="!show_resend_otp_email" class="font-semibold">Resend in {{ formattedEmailTimer }}</span><span @click="resendOtpEmail" class="text-theme-primary font-bold hover:underline" v-show="show_resend_otp_email">Resend</span></p>
                            </div>
                        </div>              
                    </div>
                </div>
                
                <div class="bg-gray-50 rounded-xl p-3 flex flex-col justify-center text-center items-center mt-5">
                    <span class="mb-1 font-semibold text-base lg:text-lg" v-text="'Mobile Number'" />
                    <div v-show="!show_otp_mobile" class="bg-theme-primaryLight px-4 py-2 rounded-full font-semibold text-theme-primary text-base flex justify-center items-center align-middle text-center my-2"><span>Verified</span><img src="@/assets/images/papsi_check_icon.svg" class="ml-1 w-5 h-5"></div>
                    <div class="p-2 space-y-3 place-items-center" v-show="show_otp_mobile">
                        <v-otp-input :is-disabled="false" ref="otp_mobile" v-show="show_otp_mobile"
                            input-classes="otp-input-register" :conditionalClass="['1', '2', '3', '4', '5', '6']" separator=" "
                            :input-type="'number'" inputmode="numeric" :num-inputs="6" @on-change="handleOnChangeMobile"
                            @on-complete="handleCompleteMobile" v-model:value="otp_mobile" :should-auto-focus="false"
                            :should-focus-order="true" :key="otpInputKey"/>

                        <div class="flex flex-col pt-1 gap-3 w-full justify-center text-center text-gray-400 text-sm">
                            <!-- <span class="text-red-500" v-text="error_otp_mobile_message" v-show="show_error_otp_mobile" /> -->
                             <div v-show="error_otp_mobile_message" class="w-full flex items-center justify-center text-center mt-2 rounded-full">
                                            <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium" 
                                            v-text="error_otp_mobile_message" 
                                />
                            </div>
                            <div class="flex flex-row gap-2 w-full justify-center text-center text-gray-400 text-sm">
                                <p>Didn't receive a code? <span v-show="!show_resend_otp_mobile" class="font-semibold">Resend in {{ formattedMobileTimer }}</span><span @click="resendOtpMobile" class="text-theme-primary font-bold hover:underline" v-show="show_resend_otp_mobile">Resend</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                
            

            </div>
            
        </Modal>
        <Modal v-show="this.show_pin_modal" v-bind:display="this.show_pin_modal" z_value="z-40"
            :default_width="'max-w-xl'"
            id='vote_modal' closable>
            <div class="pt-6">
                <div class="w-full flex flex-col">
                    <div class="" v-show="!show_con_pin">
                        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Enroll PIN</h2>
                        <p class="mb-5 text-left text-base">For enhanced security, please create a unique Personal Identification Number (PIN) for future application logins.</p>
    
                        <div class="flex flex-row w-full my-5 justify-center items-center align-center text-center">
                            <v-otp-input ref="otpInput" input-classes="otp-input-register"
                                :conditionalClass="['pin1', 'pin1', 'pin1', 'pin1', 'pin1', 'pin1']" separator=" "
                                :input-type="input_type_pin" inputmode="numeric" :num-inputs="6"
                                @on-change="changePIN" @on-complete="checkPinValidity" v-model:value="enroll_pin" :should-auto-focus="true"
                                :should-focus-order="true" :key="otpInputKey"/>
                            <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer" @click="togglePeeker">
                                <Icons v-bind:source="getImgSrc()" :width="24" />
                            </div>
                        </div>
                        
                        <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center">
                            <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base" 
                            v-text="error_pin_message"/>
                        </div>
                        
                        <!-- <Button :button_text="'NEXT'" @clicked="checkPinValidity" :disabled="!enroll_pin_btn" /> -->
                    </div>

                    <div class=" text-left" v-show="show_con_pin">
                        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Confirm PIN</h2>
                        <p class="mb-5 text-left text-base">Please re-type your Personal Identification Number (PIN) to confirm.</p>
                    
                        <div class="flex flex-row w-full my-5 justify-center items-center text-center">
                            <v-otp-input ref="conOtpInput" input-classes="otp-input-register"
                                :conditionalClass="['con1', 'con2', 'con3', 'con4', 'con5', 'con6']" separator=" "
                                @on-change="changeConPIN" @on-complete="checkPinValidity" :inputType="input_type_con" :num-inputs="6"
                                v-model:value="con_enroll_pin" :should-auto-focus="true" :should-focus-order="true"
                                :key="otpInputKey"/>
                            <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer" @click="togglePeekerCon">
                                <Icons v-bind:source="getImgSrcCon()" :width="24" />
                            </div>

                        </div>

                        <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center mb-4">
                            <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base" 
                            v-text="error_pin_message"/>
                        </div>

                        <div class="flex flex-row space-x-3 justify-center mt-2">
                            <Button @clicked="backToPin" is_secondary rounded :button_text="lang('BACK')"/>
                            <!-- <Button :button_text="'SUBMIT'" @clicked="checkPinValidity" :disabled="!enroll_conpin_btn" /> -->
                        </div>
                        
                    </div>
    
                </div>
            </div>

        </Modal>
         <Modal v-show="this.show_confirm_modal" v-bind:display="this.show_confirm_modal" @positiveClick="register" :positiveButton="'Submit'"
            @negativeClick="show_confirm_modal = false" :negativeButton="'Edit'" :closable="true"
            @closed="show_confirm_modal = false"
            :default_width="'max-w-xl'" id='confirm_modal'>
            <div class="pt-6">
                <h2 class="text-xl lg:text-2xl font-bold text-theme-primary mb-2 text-left">Confirm your Information</h2>
                <p class="mb-5 text-left text-base">Make sure all details are correct. Please review your information before submitting.</p>
            </div>

            <div class="p-5 flex flex-col rounded-2xl bg-gray-100 gap-3 text-gray-500 text-left w-full text-base">
                <p><span class="font-semibold">Full Name: </span>{{ reg_info.first_name }} {{ reg_info.middle_name }} {{ reg_info.last_name }}</p>
                <p v-if="reg_info.account_number"><span class="font-semibold">Account No.: </span>{{ reg_info.account_number }}</p>
                <p v-if="reg_info.serial_number"><span class="font-semibold">Serial No.: </span>{{ reg_info.serial_number }}</p>
                <p><span class="font-semibold">Email Address: </span>{{ reg_info.email }}</p>
                <p><span class="font-semibold">Mobile Number: </span>+63{{ reg_info.mobile_number }}</p>
                <p><span class="font-semibold">Username: </span>{{ reg_info.username }}</p>
            </div>

        </Modal>


        <div class="h-screen">

            <CardView max_width="max-w-5xl xs:mb-16 m-auto" class="h-full overflow-auto" v-show="show" text_color="bg-white text-theme-primary text-3xl"
                :class="[{ '-translate-x-0 opacity-100': this.fade, '-translate-y-full opacity-0': !this.fade, }, 'transition delay-100']">
    
    
                <div class="w-full flex flex-col xs:p-6 sm:p-6 md:p-8 xl:p-10 space-y-1 ">
                    <div  
                        class="text-md cursor-pointer text-white absolute top-4 right-4 z-10 bg-white rounded-full p-2 hover:bg-gray-50" 
                        @click="$router.back()">
                        <img src="@/assets/images/papsi_close.svg" alt="Close" class="w-6 h-6" />
                    </div>
                    <img src="https://resource.pafcpic.net/assets/papsi/papsi_logo.png" class="w-1/4 mb-2 cursor-pointer"/>
                    <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2">Create an account</h2>
                    <p class="">Please enter your personal information to proceed</p>
                    <br>
    
                    <div class="flex flex-row w-full space-x-5 xs:flex-col xs:space-x-0">
                        <TextBoxField uppercase required @changed="registerFields" @enter="registerTrigger" id="last_name" type="text"
                            placeholder="Last Name" :max_length="20"/>
                        <TextBoxField uppercase required @changed="registerFields" @enter="registerTrigger" id="first_name" type="text"
                            placeholder="First Name" :max_length="20"/>
                        <!-- <TextBoxField uppercase @changed="registerFields" id="middle_name" type="text"
                            placeholder="Middle Name" /> -->
                    </div>
                    <div class="flex flex-row space-x-5 xs:flex-col xs:space-x-0">
                        <TextBoxField uppercase @changed="registerFields" @enter="registerTrigger" :disable="disable_account" :max_length="5"
                            id="account_number" type="text" placeholder="Account No." :validateOnInput="true" :required="!disable_account"/>
                        <TextBoxField uppercase @changed="registerFields" @enter="registerTrigger" :disable="disable_serial" :max_length="serialNumberMaxLength"
                            id="serial_number" type="text" placeholder="Serial No." :validateOnInput="true" :required="true"/>
                    </div>
                    <div class="flex flex-row space-x-5 xs:flex-col xs:space-x-0">
                        <TextBoxField required @changed="registerFields" @enter="registerTrigger" id="email" type="text" :max_length="49" placeholder="Email Address"
                            :validateOnInput="true" @validationState="handleValidationState"/>
                        <TextBoxField required @changed="registerFields" @enter="registerTrigger" :max_length="9" id="mobile_number" type="mobile"
                            placeholder="Mobile Number" :validateOnInput="true" @validationState="handleValidationState"/>
                    </div>
                    <div class="flex flex-col">
                        <TextBoxField required @changed="registerFields" @enter="registerTrigger" id="username" type="text" placeholder="Username"
                            :validateOnInput="true" :max_length="23" @validationState="handleValidationState"/>
                            <form class="space-y-1">
                            <div class="flex flex-row space-x-5 xs:flex-col xs:space-x-0">
                                <TextBoxField required strength peekable @score="checkScore" @enter="registerTrigger" @changed="registerFields"
                                    id="password" type="Password" placeholder="Password" :max_length="23" :validateOnInput="true"/>
                                <TextBoxField required @changed="registerFields" @enter="registerTrigger" peekable id="confirm_password" ref="confirmPasswordField" type="Password"
                                    placeholder="Confirm Password" :confirmWith="reg_info.password" :max_length="23" :validateOnInput="true"/>
                            </div>
                        </form>
                    </div>
                    <div>
                        <div class="flex flex-row space-x-2 pt-1">
                            <Checkbox id="agree_ck" class="text-left" @changed="aggree" />
                            
                                    <div class="flex flex-row space-x-1 mt-auto mb-auto">
                                    <p>I agree with the 
                                        <span class="text-theme-primary font-bold cursor-pointer hover:underline" @click="OpenTerms">End-User License Agreement</span> and 
                                        <span class="text-theme-primary font-bold cursor-pointer hover:underline" @click="OpenPrivacy">Privacy Policy</span>
                                    </p>
                            </div>
                        </div>
                        <div class="w-full flex justify-center py-4">
                            <VueRecaptcha v-bind:sitekey="key" @verify="captchaVerify" @expired="captchaExpired"/>
                        </div>
                                                <Button :button_text="'REGISTER'" :theme="'text-white'" @clicked="show_confirm_modal = true" :disabled="this.reg_button_disable" />
    
                        <div class="flex flex-row w-full justify-center my-8">
                            <p>Already have an account? <span><router-link to="/"
                                        class="text-theme-primary hover:underline font-bold">Back to
                                        Login</router-link></span></p>
                        </div>
    
                    </div>
                </div>
            </CardView>
        </div>


   </ContainerView>

</template>
<script>
import { defineComponent } from 'vue'
import User from "@/services/User";
import TextBoxField from "@/components/controls/TextBoxField.vue";
import ContainerView from "@/components/sections/ContainerView.vue";
import CardView from "@/components/controls/CardView.vue";
import Checkbox from "@/components/controls/CheckBox.vue";
// import LinkText from "@/components/controls/LinkText.vue";
import Button from '@/components/controls/ButtonControl.vue';
import { VueRecaptcha } from "vue-recaptcha";
import Otp from '@/services/OTP';
import Modal from '@/components/controls/ModalControl.vue';
import LoadingControl from '@/components/controls/LoadingControl.vue';
import mixin from "@/mixin";
import VOtpInput from "vue3-otp-input";
import Icons from '@/components/controls/Icon.vue';

export default defineComponent({
    components: {
        TextBoxField,
        Icons,
        ContainerView,
        CardView,
        Checkbox,
        // LinkText,
        VueRecaptcha,
        Modal,
        LoadingControl,
        Button,
        VOtpInput
    },
    inject: ['setLoading'],
    data() {
        return {
            enroll_pin_btn: false,
            enroll_conpin_btn: false,
            error: false,
            note: false,
            success: false,
            warning: false,
            key: '6LdTAAQhAAAAAApdt61xDVJaAUU5Cv6opGbLJFFT',
            show: false,
            show_con_pin: false,
            note_style: '',
            otp_error_message: '',
            show_confirm_modal: false,
            fade: false,
            show_otp_email: true,
            show_otp_mobile: true,
            disable_account: false,
            disable_serial: false,
            error_pin_message: '',
            show_pin_modal: false,
            note_message: '',
            input_type_pin: 'password',
            input_type_con: 'password',
            modal_button_text: 'Next',
            modal_header_text: 'ENTER YOUR PIN',
            hash: '',
            otp: '',
            otpInputKey: 0,
            otp_pin_mobile: '',
            otp_pin_email: '',
            otp_mobile: '',
            otp_email: '',
            show_negative_button: null,
            reg_button_disable: true,
            show_message_modal: false,
            error_pin_validity: false,
            show_otp_modal: false,
            error_pin: false,
            modal_message: '',
            loading: false,
            show_resend_otp: false,
            show_resend_otp_email: false,
            show_resend_otp_mobile: false,
            timerEnabled: false,
            timer_enable_mobile: false,
            timer_enable_email: false,
            timerCount: 0,
            timer_count_email: 0,
            timer_count_mobile: 0,
            con_enroll_pin: '',
            visible: false,
            con_visible: false,
            enroll_pin: '',
            reg_pin: '',
            pin: '',
            otp_token: '',
            mobile_otp_pin: '',
            email_otp_pin: '',
            mobile_otp_token: '',
            email_otp_token: '',
            error_otp_email_message: '',
            error_otp_mobile_message: '',
            show_error_otp_mobile: false,
            show_error_otp_email: false,
            otp_pin: '',
            validationStates: {
                username: { loading: false, error: false },
                email: { loading: false, error: false },
                mobile_number: { loading: false, error: false }
            },
            reg_info: {
                last_name: '',
                middle_name: '',
                first_name: '',
                account_number: '',
                serial_number: '',
                email: '',
                mobile_number: '',
                username: '',
                password: '',
                confirm_password: '',
                aggree: false,
                score: '',
                pin: '',
                tin: '',
                captcha: false,
            },
        }

    },
    mixins: [
        mixin,
    ],
    computed: {
        formattedEmailTimer() {
            const min = Math.floor(this.timer_count_email / 60);
            const sec = this.timer_count_email % 60;
            return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
        },
        formattedMobileTimer() {
            const min = Math.floor(this.timer_count_mobile / 60);
            const sec = this.timer_count_mobile % 60;
            return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
        },
        serialNumberMaxLength() {
            return this.reg_info.serial_number.startsWith('O-') ? 6 : 5;
        },
    },
    mounted() {
        let that = this;

        that.show = true;
    },
    methods: {
        async autoLoginAfterRegister() {
            const that = this;
            const cookie = that.$cookies;
            try {
                that.setLoading(true);
                // Use the registered username and password
                const response = await User.login(that.reg_info.username, that.reg_info.password);
                let data = response.data.data;
                // Set cookies and state as in LoginView.vue
                that.$cookies.set('user', {
                    uuid: data.uuid,
                    hash: data.hash,
                    timestamp: data.timestamp,
                });
                that.$store.state.credentials.hash = data.hash;
                that.$store.state.credentials.uuid = data.uuid;
                // Call authenticated logic just like in LoginView.vue
                that.authenticated(cookie.get('user'));
            } catch (error) {
                that.setLoading(false);
                that.error = true;
                that.show_message_modal = true;
                that.modal_message = error.response?.data?.message || 'Auto-login failed. Please login manually.';
            }
        },
        authenticated(values) {
        const that = this;
        const store = that.$store;
        const state = store.state;
        const cookie = that.$cookies;

        let payload = {
            username: that.reg_info.username,
            password: that.reg_info.password,
            hash: values.hash,
            type: 1
        }

        User.authentication(payload, values.uuid).then(function (response) {
            // console.log(response);
            let data = response.data.data;

            // that.setLoading(false);
            cookie.set('user_session', {
            hash: data.hash,
            });
            state.credentials.has_pin = data.has_pin;
            state.credentials.account_no = data.info.account_number;
            state.credentials.email = data.info.email;
            state.credentials.key = data.key;
            state.credentials.mobile = data.info.mobile;
            state.credentials.name = data.info.first_name + " " + data.info.last_name;
            state.credentials.qr = data.qr;
            state.credentials.serial_no = data.info.serial_number;
            state.credentials.timestamp = response.timestamp;
            state.gaUser = data.ga;
            state.credentials.username = data.info.username;
            state.credentials.tin = data.info.tin;
            state.credentials.hash = data.hash;
            state.credentials.gender = data.info.gender;
            state.credentials.birthdate = data.info.date_of_birth;
            state.credentials.age = data.info.age;
            state.credentials.membership_type = data.info.membership_type;
            state.credentials.serial_no = data.info.serial_number;
            state.credentials.deactivated = data.deactivated;
            store.state.credentials.hash = data.hash;
            //  state.credentials.has_pin = data.has_pin;
            // state.credentials.membership_date = data.info.;
            state.credentials.registered_date = data.info.registered;
            state.logged = true;
            // that.setLoading(false);
            that.setLoading(false);
            that.$router.push('/dashboard');
            // that.getUserInfo();

        }).catch(function (error) {
            let message = error.response.data.message;
            that.modal_message = message;
            that.show_message_modal = true;
            that.error = true;
            that.error_message = true;
            that.message = message;
            // that.setLoading(false);
            that.setLoading(false);
        })
        },
        captchaExpired() {
            this.reg_info.captcha = false;
            this.enableButton();
        },
        registerTrigger() {
            if (this.reg_button_disable) return;
            this.show_confirm_modal = true;
        },
        handleCompleteMobile() {
            this.submitOtpMobile();
        },
        handleOnCompleteEmail() {
            this.submitOtpEmail();
        },
        handleValidationState({ key, loading, error }) {
            if (this.validationStates[key] !== undefined) {
            this.validationStates[key].loading = loading;
            this.validationStates[key].error = error;
            this.enableButton();
            }
        },
        checkPinValidity() {
            let that = this;

            const isSequential = (pin) => {
                return '1234567890'.includes(pin) || '0987654321'.includes(pin);
            };

            const isRepeated = (pin) => {
                return /^(\d)\1+$/.test(pin); // Matches all same digits (e.g., 111111)
            };

            // --- Validations ---
            if (that.enroll_pin === "") {
                that.error_pin_validity = true;
                that.error_pin_message = "Don't leave the PIN empty.";
                return;
            } 
            
            if (that.enroll_pin.length < 6) {
                that.error_pin_validity = true;
                that.error_pin_message = 'PIN must be at least 6 digits.';
                return;
            }

            if (isSequential(that.enroll_pin) || isRepeated(that.enroll_pin)) {
                that.error_pin_validity = true;
                that.error_pin_message = 'PIN is too weak.';
                that.enroll_pin_btn = false;
                that.enroll_pin = '';
                that.otpInputKey++;
                return;
            }

            if (that.show_con_pin) {
                if (that.con_enroll_pin === "") {
                    that.error_pin_validity = true;
                    that.error_pin_message = "Don't leave the PIN empty.";
                    
                    return;
                }

                if (that.con_enroll_pin.length < 6) {
                    that.error_pin_validity = true;
                    that.error_pin_message = 'PIN must be at least 6 digits.';
                    return;
                }

                if (that.enroll_pin !== that.con_enroll_pin) {
                    that.error_pin_validity = true;
                    that.error_pin_message = 'PINs do not match.';
                    that.enroll_conpin_btn = false;
                    that.con_enroll_pin = '';
                    that.otpInputKey++;
                    return;
                }

                that.error_pin_validity = false;
                // that.setLoading(true);
                that.setLoading(true);

                let payload = {
                    hash: that.hash,
                    pin: that.reg_pin,
                    mpin: that.enroll_pin
                };

                User.enrollPin(payload)
                    .then(function () {
                        // that.setLoading(false);
                        that.setLoading(false);
                        that.error = false;
                        that.note = false;
                        that.show_pin_modal = false;
                        that.success = true;
                        that.note_style = 'text-center';
                        that.modal_message = 'Congratulations! You have successfully created your account.';
                        that.show_message_modal = true;
                    })
                    .catch(function (error) {
                        that.note_style = "text-center";
                        // that.setLoading(false);
                        that.setLoading(false);
                        that.$refs.conOtpInput?.clearInput();
                        that.$refs.otpInput?.clearInput();
                        that.backToPin();
                        that.error = true;
                        that.show_message_modal = true;
                        that.modal_message = error.response?.data?.message || 'Something went wrong';
                    });

            } else {
                that.error_pin_validity = false;
                that.show_con_pin = true;
                that.show_negative_button = "Back";
                that.modal_button_text = "Submit";
            }
        },
        changePIN() {
            this.error_pin_message = ''
            this.enroll_conpin_btn = false;
        },
        changeConPIN() {
            this.error_pin_message = '';
            this.enroll_conpin_btn = false;
        },
        backToPin() {
            this.show_con_pin = false;
            this.error_pin_validity = false;
            this.show_negative_button = null;
            this.error_pin_message = '';
            this.modal_button_text = "Next";
        },
        togglePeeker() {
            if (this.visible == true) {
                this.input_type_pin = "password";
                this.visible = false;
            } else {
                this.input_type_pin = "number";
                this.visible = true;
            }
        },
        togglePeekerCon() {
            if (this.con_visible == true) {
                this.input_type_con = "password";
                this.con_visible = false;
            } else {
                this.input_type_con = "number";
                this.con_visible = true;
            }
        },
        getImgSrc() {
            return this.visible ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        getImgSrcCon() {
            return this.con_visible ?  "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        closed() {
            let that = this;
            that.show_message_modal = false;
            if (that.success) {
                that.note_style = 'text-center';
                that.success = false;
                that.autoLoginAfterRegister();
                // that.$router.push('/');
            } else if (that.note) {
                that.note_style = 'text-left'
                that.note = false;
                that.show_pin_modal = true;
            } else {
                that.note_style = 'text-center';
            }
        },
        handleOnChangeConPin() {
            if (this.enroll_pin.length != 6) {
                this.error_pin = true;
            } else {
                this.error_pin = false;
            }
        },
        handleOnChangeEmail() {
            this.error_otp_email_message = '';
        },
        handleOnChangeMobile() {
            this.error_otp_mobile_message = '';
        },
        OpenTerms() {
            this.$emit('OpenTerms');
        },
        OpenPrivacy() {
            this.$emit('OpenPrivacy');
        },
        otpUpdate(e) {
            let that = this;
            that.otp = e.value;
        },
        checkScore(e) {
            let that = this;
            that.reg_info.score = e;
            // console.log(that.reg_info.score);
            that.enableButton();
        },
        clicked() {
            this.$router.push('/register/validate');
        },
        captchaVerify() {
            this.reg_info.captcha = true;
            this.enableButton();
        },
        enableButton() {
            let that = this;

            // Check if any field is loading or has error
            const isAnyLoading = Object.values(that.validationStates).some(v => v.loading);
            const isAnyError = Object.values(that.validationStates).some(v => v.error);

            // Check all required fields are filled
            const requiredFieldsFilled =
                that.reg_info.first_name.trim() !== '' &&
                that.reg_info.last_name.trim() !== '' &&
                that.reg_info.username.trim() !== '' &&
                that.reg_info.password.trim() !== '' &&
                that.reg_info.confirm_password.trim() !== '' &&
                (that.reg_info.email.trim() !== '' || that.reg_info.mobile_number.trim() !== '') &&
                (that.reg_info.account_number.trim() !== '' || that.reg_info.serial_number.trim() !== '') &&
                that.reg_info.aggree &&
                that.reg_info.captcha;

            // Validation logic
            const isEmailValid = that.reg_info.email === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(that.reg_info.email);
            const isMobileValid = that.reg_info.mobile_number === '' || /^9\d{9}$/.test(that.reg_info.mobile_number);
            const isUsernameValid = that.reg_info.username.length >= 6;
            const isPasswordMatch = that.reg_info.password === that.reg_info.confirm_password;
            const isPasswordStrong = that.reg_info.score === 'Strong';
            const isAccountValid = that.reg_info.account_number === '' || that.reg_info.account_number.length === 6;
            const isSerialValid = that.reg_info.serial_number === '' ||
                (that.reg_info.serial_number.startsWith('O-')
                    ? that.reg_info.serial_number.length === 7
                    : that.reg_info.serial_number.length === 6);

            if (
                requiredFieldsFilled &&
                isUsernameValid &&
                isPasswordStrong &&
                isPasswordMatch &&
                isEmailValid &&
                isMobileValid &&
                isAccountValid &&
                isSerialValid &&
                !isAnyLoading &&
                !isAnyError
            ) {
                that.reg_button_disable = false;
            } else {
                that.reg_button_disable = true;
            }
        },

        register() {
            let payload;
            let that = this;
            // that.setLoading(true);
            that.setLoading(true);
            that.show_registration_modal = false;
            // this.show_poll_modal = true;
            payload = {
                first_name: that.reg_info.first_name,
                last_name: that.reg_info.last_name,
                middle_name: that.reg_info.middle_name,
                account_no: that.reg_info.account_number,
                serial_no: that.reg_info.serial_number,
                email: that.reg_info.email,
                mobile_no: that.reg_info.mobile_number == '' ? '' : '+63' + that.reg_info.mobile_number,
                username: that.reg_info.username,
                password: that.reg_info.password,
                con_password: that.reg_info.confirm_password,
                agreement: 1
            }
            User.signup(payload).then(function (response) {
                that.reg_pin = response.data.data.pin;
                that.otp_pin_email = response.data.data.otp.email.pin
                that.otp_pin_mobile = response.data.data.otp.mobile.pin
                that.pin = response.data.data.otp_pin
                that.hash = response.data.data.hash;
                // that.setLoading(false);
                that.setLoading(false);
                that.timer_count_email = 120;
                that.timer_count_mobile = 120;
                that.timer_enable_email = true;
                that.timer_enable_mobile = true;
                // that.timerCount = 10;
                that.note_style = "text-center"
                that.show_otp_modal = true;
                that.show_confirm_modal = false;

            }).catch(function (error) {
                that.note_style = "text-center";
                // that.setLoading(false);
                that.setLoading(false);
                that.error = true;
                that.show_message_modal = true;
                that.show_confirm_modal = false;
                that.modal_message = error.response.data.message;
                that.reg_button_disable = true;
            });
        },
        resendOtp() {
            let that = this;
            // that.setLoading(true);
            that.setLoading(true);
            that.show_resend_otp = false;
            that.timerEnabled = true;
            that.timerCount = 120;
            Otp.requestOtp(
                {
                    type: 2,
                    email: that.reg_info.email,
                    mobile: that.reg_info.mobile_number == '' ? '' : '+63' + that.reg_info.mobile_number,
                    name: that.reg_info.first_name,
                    pin: that.pin,
                }
            ).then(function (response) {
                that.otp_pin = response.data.data.pin;
                // that.setLoading(false);
                that.setLoading(false);
                that.show_otp_modal = true;

            }).catch(function () {
                that.note_style = "text-center";
                // that.setLoading(false);
                that.setLoading(false);
                that.modal_type = 1;
            });
        },
        resendOtpEmail() {
            let that = this;
            // that.setLoading(true);
            that.show_resend_otp = false;
            that.timer_enable_email = true;
            that.timer_count_email = 120;
            Otp.requestOtp(
                {
                    type: 2,
                    email: that.reg_info.email,
                    // mobile: that.reg_info.mobile_number == '' ? '' : '+63' + that.reg_info.mobile_number,
                    name: that.reg_info.first_name,
                    pin: that.otp_pin_email,
                }
            ).then(function (response) {
                that.otp_pin = response.data.data.pin;
                // that.setLoading(false);
                that.show_otp_modal = true;

            }).catch(function () {
                that.note_style = "text-center";
                // that.setLoading(false);
                that.modal_type = 1;
            });
        },
        resendOtpMobile() {
            let that = this;
            // that.setLoading(true);
            that.show_resend_otp = false;
            that.timer_enable_mobile = true;
            that.timer_count_mobile = 120;
            Otp.requestOtp(
                {
                    type: 2,
                    // email: that.reg_info.email,
                    mobile: that.reg_info.mobile_number == '' ? '' : '+63' + that.reg_info.mobile_number,
                    name: that.reg_info.first_name,
                    pin: that.otp_pin_mobile,
                }
            ).then(function (response) {
                that.otp_pin = response.data.data.pin;
                // that.setLoading(false);
                that.show_otp_modal = true;

            }).catch(function () {
                that.note_style = "text-center";
                // that.setLoading(false);
                that.modal_type = 1;
            });
        },
        createUser() {
            let payload;
            let that = this;
            that.show_otp_modal = false;
            payload = {
                mobile_otp_pin: that.mobile_otp_pin,
                mobile_otp_token: that.mobile_otp_token,
                email_otp_pin: that.email_otp_pin,
                email_otp_token: that.email_otp_token,
                pin: that.reg_pin,
                hash: that.hash,
                first_name: that.reg_info.first_name,
                last_name: that.reg_info.last_name,
                account_no: that.reg_info.account_number,
                middle_name: that.reg_info.middle_name,
                serial_no: that.reg_info.serial_number,
                username: that.reg_info.username,
                email: that.reg_info.email,
                mobile_no: that.reg_info.mobile_number == '' ? '' : '+63' + that.reg_info.mobile_number,
                password: that.reg_info.password,
                con_password: that.reg_info.confirm_password,
                tin: that.reg_info.tin,
                agreement: 1
            }
            User.createUser(payload).then(function () {
                // that.setLoading(false);
                that.setLoading(false);
                that.show_otp_modal = false;
                that.note = true;
                that.note_style = "text-left";
                that.show_message_modal = true;
                that.success = false;
                that.error = false;
                that.modal_message = "For enhanced security, please create a unique Personal Identification Number (PIN) for future application logins. This PIN should be different from your current password."
                // that.note_message ="";
                // that.show_pin_modal = true;
            }).catch(function (error) {
                that.note_style = "text-center";
                // that.setLoading(false);
                that.setLoading(false);
                that.modal_type = 2;
                that.error = true;
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
            });
        },
        submitOtp() {
            let that = this;
            // that.setLoading(true);
            that.setLoading(true);
            Otp.validate({ otp: that.otp, type: 2, pin: that.pin }).then(function (response) {
                that.show_otp_modal = false;
                that.otp_token = response.data.data.otp_token;
                that.otp_pin = response.data.data.otp_pin;
                that.createUser();
                //   that.pin = '';
                //   that.otp = '';
            }).catch(function (error) {
                that.note_style = "text-center";
                that.error = true;
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                // that.setLoading(false);
                that.setLoading(false);
            });
        },
        submitOtpEmail() {
            let that = this;
            // that.setLoading(true);
            that.setLoading(true);
            Otp.validate({ otp: that.otp_email, type: 2, pin: that.otp_pin_email }).then(function (response) {
                //   that.show_otp_modal= false;
                that.show_otp_email = false;
                //   that.otp_token = response.data.data.otp_token;
                //   that.otp_pin = ;
                that.email_otp_pin = response.data.data.otp_pin;
                that.email_otp_token = response.data.data.otp_token;
                if (that.show_otp_email == false && that.show_otp_mobile == false) {
                    // that.setLoading(true);
                    that.setLoading(true);
                    that.show_error_otp_email = false;
                    that.createUser();
                } else {
                    // that.setLoading(false);
                    that.setLoading(false);
                }
                //   that.pin = '';
                //   that.otp = '';
            }).catch(function (error) {
                that.note_style = "text-center";
                that.$refs.otp_email.clearInput();
                that.error = true;
                that.otpInputKey++; 
                that.show_error_otp_email = true;
                that.error_otp_email_message = error.response.data.message;
                // that.setLoading(false);
                that.setLoading(false);
            });
        },
        submitOtpMobile() {
            let that = this;
            // that.setLoading(true);
            that.setLoading(true);
            Otp.validate({ otp: that.otp_mobile, type: 2, pin: that.otp_pin_mobile }).then(function (response) {
                //   that.show_otp_modal= false;
                that.show_otp_mobile = false;
                //   that.otp_token = ;
                //   that.otp_pin = ;
                that.mobile_otp_pin = response.data.data.otp_pin;
                that.mobile_otp_token = response.data.data.otp_token;
                if (that.show_otp_email == false && that.show_otp_mobile == false) {
                    // that.setLoading(true);
                    that.show_error_otp_mobile = false;
                    that.createUser();
                } else {
                    // that.setLoading(false);
                    that.setLoading(false);
                }
            }).catch(function (error) {
                that.note_style = "text-center";
                that.$refs.otp_mobile.clearInput();
                that.error = true;
                that.otpInputKey++; 
                that.show_error_otp_mobile = true;
                that.error_otp_mobile_message = error.response.data.message;
                // that.setLoading(false);
                that.setLoading(false);
            });
        },
        aggree(n) {
            let that = this;
            that.reg_info.aggree = n;
            this.enableButton();
        },
        registerFields(e) {
            let that = this;
            let obj = that.reg_info;
            obj[e.key] = e.value;

            if (e.key == "account_number") {
                if (that.reg_info.account_number.length > 0) {
                    that.disable_serial = true;
                } else {
                    that.disable_serial = false;
                }
            }

            if (e.key == "serial_number") {
                if (that.reg_info.serial_number.length > 0) {
                    that.disable_account = true;
                } else {
                    that.disable_account = false;
                }
            }
            this.enableButton();
        },
    },
    watch: {
        show() {
            setTimeout(() => {
                this.fade = true;
            }, 100);
        },
        timerCount: {
            handler(value) {
                if (value > 0 && this.timerEnabled) {
                    this.show_resend_otp = false;
                    setTimeout(() => {
                        this.timerCount = this.timerCount - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    this.show_resend_otp = true;
                    this.timerEnabled = false; // run your function here
                }
            },
            immediate: true
        },
        timer_count_email: {
            handler(value) {
                if (value > 0 && this.timer_enable_email) {
                    this.show_resend_otp_email = false;
                    setTimeout(() => {
                        this.timer_count_email = this.timer_count_email - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    if (this.show_otp_email) {
                        this.show_resend_otp_email = true;
                    }
                    this.timer_enable_email = false; // run your function here
                }
            },
            immediate: true
        },
        timer_count_mobile: {
            handler(value) {
                if (value > 0 && this.timer_enable_mobile) {
                    this.show_resend_otp_mobile = false;
                    setTimeout(() => {
                        this.timer_count_mobile = this.timer_count_mobile - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    if (this.show_otp_mobile) {
                        this.show_resend_otp_mobile = true;
                    }
                    this.timer_enable_mobile = false; // run your function here
                }
            },
            immediate: true
        },
        'reg_info.password'(val) {
            // Find the confirm password TextBoxField and trigger validation
            this.$nextTick(() => {
                const confirmField = this.$refs.confirmPasswordField;
                if (confirmField && confirmField.validateField) {
                    confirmField.validateField(this.reg_info.confirm_password);
                }
            });
        },
        'reg_info.confirm_password'(val) {
            // Find the confirm password TextBoxField and trigger validation
            this.$nextTick(() => {
                const confirmField = this.$refs.confirmPasswordField;
                if (confirmField && confirmField.validateField) {
                    confirmField.validateField(val);
                }
            });
        },
    }
})
</script>

<style>
.otp-input-register {
  width: 3.2rem;
  height: 4rem ;
  padding: 4px;
  font-size: 2.5rem ;
  margin: 0 0.3rem;
  border-radius: 0.75rem;
  border: 0.05rem solid #dfdfdf !important;
  background-color: #f3f4f6;
  text-align: center;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif !important;
}

.otp-input-register::-webkit-inner-spin-button,
.otp-input-register::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp-input-register:focus {
  outline: none;
  border: 0.2rem solid #016B00 !important;
}

/* Tablet (e.g., iPad) */
@media (max-width: 1024px) {
  .otp-input-register {
    width: 3.5rem !important;
    height: 4.5rem !important;
    font-size: 3rem !important;
    margin: 0 0.3rem;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .otp-input-register {
    width: 3rem !important;
    height: 4rem !important;
    font-size: 2.5rem !important;
    margin: 0 0.2rem !important;
}
}

/* Extra small mobile (e.g., older phones) */
@media (max-width: 480px) {
  .otp-input-register {
    width: 2.5rem !important;
    height: 3rem !important;
    font-size: 1.5rem !important;
    margin: 0 0.2rem !important;
    border-radius: 0.6rem !important;
  }
}

input::placeholder {
    font-size: 15px;
    text-align: center;
    font-weight: 600;
}
</style>
